import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { ICoverBlockData } from './ICoverBlockData';

export const DynamicCoverBlock = dynamic<BlockProps<ICoverBlockData>>(() =>
    import('./CoverBlock').then(md => md.CoverBlock),
);
